const initialState = {
    orders: [],
    selectedTab: 'pending',
};
const orders = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_USER_ORDERS':
            return {...state, [action.name]: action.value};
       	
        default:
            return state;
    }
};

export default orders;
